//import { render } from '@wordpress/element';
import { createRoot } from '@wordpress/element';
import {Provider} from "react-redux";
import Store from "./store/Store";
import './scss/app.scss';
import App from "./App";



const rootElement = document.getElementById('wooArchiveRoot');
const root = createRoot(rootElement);
root.render( 
    <Provider store={Store}>
        <App />
    </Provider>
);

